import { Box, Divider } from '@mui/material';
import styled from 'styled-components';

const DividerBox = styled(Box)`
  margin-left: -2rem;
  margin-top: 1rem;
  width: calc(100% + 55px);

  .divider {
    background-color: ${(props) => props.theme.palette.divider};
  }
`;

export const BaseDivider = () => {
  return (
    <DividerBox>
      <Divider className="divider" />
    </DividerBox>
  );
};
